// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AdobePremiereIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <g clipPath="url(#adobePremiere_svga)">
      <path
        fill="#00005B"
        d="M18.41 2H5.6A3.6 3.6 0 0 0 2 5.59V18.4C2 20.4 3.6 22 5.59 22H18.4C20.4 22 22 20.4 22 18.41V5.6C22 3.6 20.4 2 18.41 2"
      />
      <path
        fill="#99F"
        d="M9.71 7.3c2.62 0 4.09 1.23 4.09 3.28 0 2.4-2 3.36-3.87 3.36H8.67v2.59H6.1V7.3zM8.67 9.5v2.25H9.8c.78 0 1.33-.31 1.33-1.11 0-.73-.47-1.14-1.28-1.14zM17.37 9.22c.56 0 1.02.07 1.22.14v1.87a4 4 0 0 0-.74-.07c-.51 0-.8.04-1.06.14v5.23h-2.4v-6.7c.86-.39 1.73-.6 2.98-.6"
      />
    </g>
    <defs>
      <clipPath id="adobePremiere_svga">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>,
  "AdobePremiere",
);
export default AdobePremiereIcon;
